export default "__VITE_ASSET__BOXo8oHE__"